import Swal from "sweetalert2";
import axios from "@/libs/axios";
import {$themeConfig} from "@themeConfig";
import {$appConfig} from "../../../appConfig";

export default {
    sequenceNumber:'',
    uploadPercentage:undefined,
   async upload(file) {
        Swal.showLoading();
        let data = new FormData()
        data.append('files', file)
        let result = null;
//ss
        // await Swal.fire( 'در حال آپلود', `<p> ${this.uploadPercentage} </p>`)
        // await axios.post( $appConfig.endpoint.baseUrl +'/storage/'+ `/Uploads/file`,
        await axios.post( $appConfig.endpoint.baseUrl+'/Uploads/file',
            data,
            {
                
                header: {
                    'Content-Type': 'multipart/form-data ,boundary=----WebKitFormBoundary7MA4YWxkTrZu0gW'
                },
                onUploadProgress: function( progressEvent ) {
                    this.uploadPercentage = parseInt(Math.round( (progressEvent.loaded/progressEvent.total)*100));
                    console.log(this.uploadPercentage)
                }.bind(this)
            }
        ).then(response => {
            console.log(response);
            Swal.close();
            result =  response.data.data;
            
        }).catch(error => {
            Swal.close();
            console.log('error', error)
        })

       return result;
    },


    async uploadCh(){
        console.log('test')
    },

    makeTotalCheckSum() {
        (async () => {
            // eslint-disable-next-line
            const blobSlice = File.prototype.slice || File.prototype.mozSlice || File.prototype.webkitSlice;
            const [file] = [this.file];
            const vm = this;
            // Read in chunks of 15MB ↓
            const chunkSize = 15728640 ;
            const chunks = Math.ceil(file.size / chunkSize);
            let currentChunk = 0;
            const spark = new SparkMD5.ArrayBuffer();
            // console.log('████', spark);
            const fileReader = new FileReader();
            function loadNext() {
                const start = currentChunk * chunkSize;
                const end = ((start + chunkSize) >= file.size) ? file.size : start + chunkSize;
                fileReader.readAsArrayBuffer(blobSlice.call(file, start, end));
            }
            fileReader.onload = await function (e) {
                // console.log('read chunk nr', currentChunk + 1, 'of', chunks);
                // Append array buffer ↓
                spark.append(e.target.result);
                currentChunk += 1;
                if (currentChunk < chunks) {
                    loadNext();
                } else {
                    vm.totalFileCheckSum = spark.end();
                    // console.log('finished loading');
                    // Compute hash ↓
                    // console.info('computed hash', spark.end());
                    // alert(spark.end());
                    // for test
                }
            };
            fileReader.onerror = function () {
                // console.warn('oops, something went wrong.');
            };
            loadNext();
        })();
    },
    // 4st
    uploadInit() {
        axios({
            method: 'get',
            headers: {
            },
            url: `${this.baseURL}/api/Uploads?CheckSum=${this.totalFileCheckSum}`,
        }).then((response) => {
            if (response.data.isSuccess) {
                this.uploadId = response.data.data;
                if (!response.data.isSuccess) {
                    this.makeToast('warning', 'Something wrong', 2000);
                    this.videoSrc = response.data.data;
                    this.progress = 100;
                } else {
                    this.videoSrc = response.data.data;
                    this.$refs.preview.pause();
                    this.uploadStarted = true;
                    this.uploadStoped = false;
                    this.uploadPaused = false;
                    this.uploading = true;
                    this.uploadFinished = false;
                    this.uploadChunk();
                }
                // console.log(response.data.data);
            } else {
                this.makeToast('warning', 'خطا در ثبت ویدئو', 2000);
            }
        }, (error) => {
            this.makeToast('error', this.errorHandler(error), 3000);
        });
    },
    // 5st
    uploadChunk() {
        this.totalPartNumber = Math.ceil(this.file.size / this.chunkSize);
        // eslint-disable-next-line
        this.progress = (((this.sequenceNumber) / this.totalPartNumber) * 100).toFixed(0);
        this.vExt = this.file.type.split('/').pop();
        this.az = ((this.sequenceNumber - 1) * this.chunkSize);
        if (this.sequenceNumber === this.totalPartNumber) {
            this.chunkSize = this.file.size % this.chunkSize;
        }
        this.ta = this.az + this.chunkSize;
        this.uploadPart();
    },
    // 6st ↓
    uploadPart() {
        (async () => {
            const [file] = [this.file];
            const sliced = this.file.slice(this.az, this.ta, file.type);
            this.lastFile = sliced;
            // const arrayBuffer = await sliced.arrayBuffer();
            // console.log('------*****------', arrayBuffer.byteLength);
            // const chars = new Uint8Array(arrayBuffer);
            // eslint-disable-next-line
            // const hash = this.CryptoJS.MD5(this.CryptoJS.enc.Utf8.stringify(chars));
            // const md5 = hash.toString(this.CryptoJS.enc.Hex);
            const vm = this;
            const reader = new FileReader();
            let hash = '';
            reader.readAsBinaryString(file);
            reader.onloadend = function () {
                hash = vm.$CryptoJS.MD5(reader.result).toString();
                vm.partCheckSum = hash;
                vm.uploadChunkPart(sliced);
            };
        })();
    },
    // 7st
    uploadChunkPart(part) {
        const formData = new FormData();
        formData.append('files', part);
        this.cancelToken = axios.CancelToken;
        this.request = this.cancelToken.source();
        if (true) {
            axios({
                method: 'post',
                url: `${this.baseURL}/api/Uploads`,
                data: formData,
                headers: {
                    'Content-Type': 'multipart/form-data',
                    UploadId: this.uploadId,
                    PartSize: this.chunkSize,
                    SequenceNumber: this.sequenceNumber,
                    TotalPartNumber: this.totalPartNumber,
                },
                cancelToken: this.request.token,
            }).then((response) => {
                this.uploading = false;
                if (response.data.isSuccess) {
                    if (this.sequenceNumber < this.totalPartNumber) {
                        this.sequenceNumber += 1;
                    } else {
                        this.completeUpload();
                    }
                } else {
                    this.makeToast('info', 'خطا در آپلود تصویر', 2000);
                }
            }, (error) => {
                this.makeToast('error', this.errorHandler(error), 3000);
            }).catch(() => {
                this.makeToast('info', 'آپلود ویدئو متوقف شد', 4000);
            });
        }
    },
    pauseUpload() {
        this.uploadStarted = true;
        this.uploadStoped = false;
        this.uploadPaused = true;
        this.uploading = true;
    },
    resumeUpload() {
        this.uploadStarted = true;
        this.uploadStoped = false;
        this.uploadPaused = false;
        this.uploading = true;
    },
    stopUpload() {
        this.request.cancel();
        // this.request = null;
        this.uploadStarted = false;
        this.uploadStoped = true;
        this.uploadPaused = false;
        this.uploading = false;
        this.progress = 0;
    },
    makeMD5() {
        return this.CryptoJS.MD5(this.test).toString();
    },
    completeUpload() {
        const b = axios({
            method: 'get',
            url: `${this.baseURL}/api/Uploads/compelete`,
            headers: {
                'Content-Type': 'multipart/form-data',
                UploadId: this.uploadId,
                FileExt: `.${this.vExt}`,
                CheckSum: this.totalFileCheckSum,
                TotalPartNumber: this.totalPartNumber,
            },
            cancelToken: this.request.token,
            // onUploadProgress: (progressEvent) => {
            // eslint-disable-next-line
            // this.progress = parseInt(Math.round((progressEvent.loaded / progressEvent.total) * 100), 10);
            // console.log(this.progress);
            // },
        }).then((response) => {
            this.uploading = false;
            if (response.data.isSuccess) {
                this.videoSrc = response.data.data;
            } else {
                this.makeToast('info', 'خطا در آپلود', 2000);
            }
        }, (error) => {
            this.makeToast('error', this.errorHandler(error), 3000);
        });
        b.catch(() => {
            this.makeToast('info', 'آپلود ویدئو متوقف شد', 4000);
        });
    },
    createChunks() {
        const [f] = [this.file];
        // const myBlob = new Blob(f.slice, { type: 'video/mp4' });
        // eslint-disable-next-line
        const myBlob = f.slice(this.sequenceNumber - 1, this.sequenceNumber - 1 + 1000, 'video/mp4');
        const myReader = new FileReader();
        myReader.onload = function d() {
            // console.log(myBlob);
            // console.log(JSON.stringify(myReader.result));
        };
        myReader.readAsArrayBuffer(myBlob);
    },
}
